import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('approval_decision_policy'),
    subtitle: defineMessage('if_an_approver_has_been_al_should_be_applied_to'),
    allStepLabel: defineMessage('all_steps_at_once'),
    currentStepLabel: defineMessage('only_to_the_current_step'),
};
